<template>
    <v-container>

        <v-row>
            <v-col>

                <div class="headline">Bedrifter</div>
                <br>

                <v-row align="center" class="elevation-1 white px-3 mx-1">
                    <v-col cols="auto">
                        <v-btn :disabled="this.$store.getters.rights > 0" @click="showDialog" color="success">
                            <v-icon left>mdi-plus-circle-outline</v-icon>
                            Ny bedrift
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-text-field v-model="search" label="søk" append-icon="mdi-magnify" single-line></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table :items="companies" :headers="headers" :loading="companiesLoading" :search="search" hide-default-footer :items-per-page="-1" :mobile-breakpoint=0>
                            <template v-slot:item="{item}">
                                <tr style="white-space: nowrap">
                                    <td>{{item.name}}</td>
                                    <td>{{item.createdBy ? item.createdBy.name: '?'}}</td>
                                    <td>{{item.updatedBy ? item.updatedBy.name: '?'}}</td>
                                    <td>
                                        <v-icon :disabled="$store.getters.rights > 0" @click="edit(item)" color="info">mdi-pencil</v-icon>
                                        <v-icon :disabled="$store.getters.rights > 0" @click="deleteCompany = item.id" color="info">mdi-delete</v-icon>

                                        <v-tooltip bottom v-if="deleteCompany == item.id">
                                            <v-icon slot="activator" v-if="deleteCompany == item.id" @click="deleteCompany = 0" color="info" class="mx-2">thumb_down_alt</v-icon>
                                            <span>Avbryt</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="deleteCompany == item.id">
                                            <v-icon slot="activator" v-if="deleteCompany == item.id" @click="del(item)" color="error" class="mx-2">thumb_up_alt</v-icon>
                                            <span>Slett</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogVisible" :width="$vuetify.breakpoint.smAndDown? '100%' : '50%'">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    {{isNewCompany ? 'Ny bedrift' : 'Endre bedrift'}}
                    <v-spacer></v-spacer>
                    <v-btn @click="cancel" fab small>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="companyForm" v-model="companyValid">
                        <v-text-field label="Navn" v-model="companyName" type="text" :rules="[v => !!v && v.length > 1 || 'Påkrevd og minst 2 bokstaver']"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cancel">Avbryt</v-btn>
                    <v-btn @click="save" color="success">Lagre</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// import axios from "axios";
export default {
    data() {
        return {
            isNewCompany: true,
            companyValid: false,
            companyName: "",
            companyId: null,
            dialogVisible: false,
            deleteCompany: 0,
            companies: [],
            companiesLoading: false,
            headers: [
                { text: "Navn", value: "name" },
                { text: "Laget av", value: "createdBy" },
                { text: "Endret av", value: "updatedBy" },
                { text: "Handlinger", sortable: false }
            ],
            search: ""
        };
    },
    methods: {
        showDialog: function() {
            this.dialogVisible = true;
        },
        del: function(company) {
            this.axios.delete(`/company/${company.id}`).then(response => {
                if (response.data.success) {
                    let c = this.companies.find(c => c.id == company.id);
                    let index = this.companies.indexOf(c);
                    this.companies.splice(index, 1);
                    this.clearDialog();
                }
            });
        },
        edit: function(company) {
            this.deleteCompany = 0;

            this.companyId = company.id;
            this.companyName = company.name;
            this.isNewCompany = false;
            this.dialogVisible = true;
        },
        cancel: function() {
            this.clearDialog();
        },
        save: function() {
            if (this.$refs.companyForm.validate()) {
                if (this.isNewCompany) {
                    var params = {};
                    Object.assign(params, this.axios.defaults.params);

                    params.includes = "createdBy,updatedBy";

                    this.axios
                        .put(
                            `/company`,
                            { name: this.companyName },
                            {
                                params: params
                            }
                        )
                        .then(response => {
                            if (response.data.success) {
                                this.companies.push(response.data.data);
                            }
                        })
                        .then(() => {
                            this.clearDialog();
                        });
                } else {
                    this.axios
                        .post(`/company/${this.companyId}`, {
                            name: this.companyName
                        })
                        .then(response => {
                            if (response.data.success) {
                                var params = {};
                                Object.assign(params, this.axios.defaults.params);

                                params.includes = "createdBy,updatedBy";

                                return this.axios
                                    .get(`/company/${this.companyId}`, {
                                        params: params
                                    })
                                    .then(response => {
                                        if (response.data.success) {
                                            let company = this.companies.find(c => {
                                                return c.id == this.companyId;
                                            });
                                            Object.assign(company, response.data.data);
                                            return;
                                        }
                                    });
                            }
                        })
                        .then(() => {
                            this.clearDialog();
                        });
                }
            }
        },
        clearDialog: function() {
            this.dialogVisible = false;
            this.$refs.companyForm.reset();
            this.companyName = "";
            this.companyId = null;
            this.isNewCompany = true;
            this.deleteCompany = 0;
        }
    },
    mounted() {
        this.companiesLoading = true;

        var params = {};
        Object.assign(params, this.axios.defaults.params);

        params.includes = "createdBy,updatedBy";

        this.axios
            .get(`/company`, {
                params: params
            })
            .then(response => {
                if (response.data.success) {
                    this.companies = response.data.data;
                }
            })
            .finally(() => {
                this.companiesLoading = false;
            });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
</style>
